import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.typography.pxToRem(64),
  [theme.breakpoints.down('xl')]: {
    marginBottom: theme.typography.pxToRem(48),
  },
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.typography.pxToRem(40),
  },

  '& .HSBackButtonWrapper': {
    marginBottom: theme.spacing(6.375),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  '& .HSBackButton': {
    padding: theme.spacing(1.875, 0, 1.875, 0.25),
    fontSize: theme.spacing(2),
  },
  '& .HSBackIcon': {
    position: 'relative',
    top: theme.typography.pxToRem(1),
  },
  '& .HSSubtitle': {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(21),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

export default StyledBox;
